module.exports = __webpack_public_path__ + "img/snow-4.edea9910.svg";